import React from "react";
import { Helmet } from "react-helmet-async";
import { buildPlayBoardSeoMeta } from "../../config/playBoardSeo";

/**
 * Full OG/Twitter/canonical meta for indexable jigsaw & sliding board play URLs.
 * @see puzzle-be/docs/play-url-seo-frontend-prompt.md
 */
export default function PlayBoardSeoHead({
    kind,
    storyId,
    boardId,
    story = null,
    board = null,
    noindex = false,
}) {
    if (!storyId || !boardId || !kind) return null;

    const meta = buildPlayBoardSeoMeta({
        kind,
        story,
        board,
        storyId,
        boardId,
        noindex,
    });

    return (
        <Helmet>
            <title>{meta.fullTitle}</title>
            <meta name="description" content={meta.description} />
            <link rel="canonical" href={meta.playUrl} />
            <meta name="robots" content={meta.robots} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={meta.playUrl} />
            <meta property="og:title" content={meta.title} />
            <meta property="og:description" content={meta.description} />
            <meta property="og:image" content={meta.imageUrl} />
            <meta property="og:image:secure_url" content={meta.imageUrl} />
            <meta property="og:image:type" content="image/png" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:site_name" content="Puzzle Interact" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={meta.title} />
            <meta name="twitter:description" content={meta.description} />
            <meta name="twitter:image" content={meta.imageUrl} />
            <meta name="twitter:url" content={meta.playUrl} />
        </Helmet>
    );
}
